// extracted by mini-css-extract-plugin
export var buttoncontainer = "styles-module--buttoncontainer--DSChS";
export var buttondisallow = "styles-module--buttondisallow--1+ihT";
export var cookiebanner = "styles-module--cookiebanner--GRFQk";
export var cookietext = "styles-module--cookietext--3ezHZ";
export var innercontainer = "styles-module--innercontainer--0Ruff";
export var moretext = "styles-module--moretext--HoDyZ";
export var textcontainer = "styles-module--textcontainer--NNw8N";